import axios from 'axios'
import { storeAllEntities } from '@/helpers/store'
import qs from 'qs'

const getDefaultSubscribableState = () => {
  return {
    subscribables: {},
    // only for studyplan
    mySubscriptions: {},
    studentCourseContexts: {},
    myAdvises: {},
    studentSubscribableAnswers: {},
    subscriptions: {},
    students: {}
  }
}

export default {
  state: getDefaultSubscribableState,
  mutations: {
    RESET_SUBSCRIBABLE_STATE (state) {
      Object.assign(state, getDefaultSubscribableState())
    },
  },
  actions: {
    getSubscribables ({ commit, state }, { apiRoute, queryParams = null }) {
      return axios.get(apiRoute, {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params)
        },
      }).then(storeAllEntities(commit))
    },
    getSubscribablesMatrixExport ({ commit, state }, { apiRoute, queryParams = null }) {
      return axios.get(apiRoute, {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params)
        },
      })
    },
    getFilterOptions ({ commit, state }, { apiRoute, queryParams }) {
      return axios.get(apiRoute, {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params)
        },
      })
    },
    storeSubscriptionsWerkplekken ({ commit, state }, { apiRoute, data }) {
      return axios.post(apiRoute, data)
        .then(storeAllEntities(commit))
    },
    resetSubscribableState ({ commit, state }) {
      commit('RESET_SUBSCRIBABLE_STATE')
    },
  },
  getters: {},
}
